import dynamicLocalization from "@/mixins/dynamic-localization";
import DateToFormat from "@/components/date-to-format/index";

export default {
  props: {
    events: {
      type: Array,
      required: true,
    },
    initialSelectedEvent: {
      type: Object,
      required: false,
      default: null,
    },
  },
  mixins: [dynamicLocalization],
  components: {
    DateToFormat,
  },
  data() {
    return {
      selectedEvent: this.initialSelectedEvent,
    };
  },
  computed: {
    dateIndicators() {
      const dateIndicators = [];
      let lastDate = null;

      const getStartDate = function (event) {
        const dateData =
          event.times.start ||
          event.times.start_approximately ||
          event.times.doors_open;

        if (!dateData) {
          return null;
        }

        const date = new Date(dateData);
        date.setHours(0);
        date.setMinutes(0);

        return date;
      };

      for (let eventIndex = 0; eventIndex < this.events.length; eventIndex++) {
        const event = this.events[eventIndex];

        const nextEvent =
          eventIndex < this.events.length - 1
            ? this.events[eventIndex + 1]
            : null;

        const startDate = getStartDate(event);
        const nextStartDate = nextEvent ? getStartDate(nextEvent) : null;

        if (lastDate === startDate.getTime()) {
          if (!nextStartDate || lastDate !== nextStartDate.getTime()) {
            dateIndicators.push(-1);
          } else {
            dateIndicators.push(-2);
          }
        } else {
          dateIndicators.push(startDate);
          lastDate = startDate.getTime();
        }
      }

      return dateIndicators;
    },
  },
  methods: {
    selectEvent(event) {
      this.selectedEvent = event;
      this.$emit("selectEvent", event);
    },
    scrollEventIntoView(event) {
      const index = this.events.indexOf(event);
      const element = this.$refs.drawer.childNodes[0].childNodes[index];
      let scrollOffset = element.offsetLeft;
      this.$refs.drawer.scrollLeft = scrollOffset;
    },
    fixPosition() {
      const height = this.$refs.drawer.offsetHeight;
      this.$refs.placeholder.style.height = `${height}px`;
    },
  },
  mounted() {
    if (!this.initialSelectedEvent) {
      this.selectEvent(this.events[0]);
    }

    this.fixPosition();
    this.scrollEventIntoView(this.selectedEvent);
  },
  watch: {
    initialSelectedEvent(newVal, oldVal) {
      if (newVal !== this.selectedEvent) {
        this.selectedEvent = newVal;
        this.scrollEventIntoView(newVal);
      }
    },
  },
};
